webpackJsonp([8],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/display/lib/api.js
// //////////////////////////////////////////////////////////////////////////////////
//
//  ใส่ core และ o365 ด้านหลังเสมอ  api ทำไว้ให้แล้ว เพื่อให้ tablet สามารถใช้งาน depa ได้ด้วย
//
////////////////////////////////////////////////////////////////////////////////////

// export const CORE_API_ENDPOINT = `http://localhost:2000/core`
// export const O365_API_ENDPOINT = `http://localhost:2000/o365`
// export const CORE_SOCKET_ENDPOINT = `/notification/socket`
// export const CORE_SOCKET = `http://localhost:2000`
// export const CORE_FRONTEND = 'http://localhost:2000'


//produc
// export const CORE_API_ENDPOINT = `/api/core`
// export const O365_API_ENDPOINT = `/api/o365`
// export const CORE_SOCKET_ENDPOINT = `/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = ``

// Dev .9
// export const CORE_API_ENDPOINT = `http://10.0.30.9:8803/api/core`
// export const O365_API_ENDPOINT = `http://10.0.30.9:8803/api/o365`
// export const CORE_SOCKET_ENDPOINT = `/api/notification/socket`
// export const CORE_SOCKET = `http://10.0.30.9:8803`
// export const CORE_FRONTEND = `http://10.0.30.9:8801/api`

// export const CORE_API_ENDPOINT = `https://displayweb.rmbainisys.com/depa/core`
// export const O365_API_ENDPOINT = `https://displayweb.rmbainisys.com/depa/o365`
// export const CORE_SOCKET_ENDPOINT = `/depa/notification/socket`
// export const CORE_SOCKET = `https://displayweb.rmbainisys.com`

//10.0.30.9
// export const CORE_API_ENDPOINT = `/depa/core`
// export const O365_API_ENDPOINT = `/depa/o365`
// export const CORE_SOCKET_ENDPOINT = `/depa/notification/socket`
// export const CORE_SOCKET = ``

//'/api/notification/socket'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
// `https://rmdtac.com/core`
// `https://rmdtac-uat2.com/core`
// `https://dtacbainisys.com/core`

//10.0.30.9
// export const CORE_API_ENDPOINT = `http://10.0.30.9:8802/api/core`
// export const O365_API_ENDPOINT = `http://10.0.30.9:8802/api/o365`
// export const CORE_SOCKET_ENDPOINT = `http://10.0.30.9:8802/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = 'http://10.0.30.9:8802/api'

// export const TIME_BACK_TO_HOME = 60000
// export const TIME_INTERVAL = 60000

//Prod
// export const CORE_API_ENDPOINT = `https://rmtbq.com/api/core`
// export const O365_API_ENDPOINT = `https://rmtbq.com/api/o365`
// export const CORE_SOCKET_ENDPOINT = `https://rmtbq.com/api/notification/socket`
// export const CORE_SOCKET = ``
// export const CORE_FRONTEND = 'https://rmtbq.com/api'
// export const TIME_BACK_TO_HOME = 60000
// export const TIME_INTERVAL = 60000

//Build new 2020
var CORE_API_ENDPOINT = '/api/core';
var O365_API_ENDPOINT = '/api/o365';
var CORE_SOCKET_ENDPOINT = '/api/notification/socket';
var CORE_SOCKET = '';
var CORE_FRONTEND = '/api';
var TIME_BACK_TO_HOME = 60000;
var TIME_INTERVAL = 60000;
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(429);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(430);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/display/lib/auth.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// import jwt from 'jsonwebtoken'

var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var FIRSTNAME = 'firstName';
var LASTNAME = 'lastName';
var EMAIL = 'email';
var IS_ADMIN = 'isAdmin';
var MEETINGROOMID = 'meetingRoomId';
var MEETINGROOMID_HEADER = 'meetingRoomId_header';
var MEETINGROOMID_FOOTER = 'meetingRoomId_FOOTER';

function getCookie(key) {
    var value = js_cookie_default.a.get(key);
    var setValue = '';
    if (typeof value === 'string') {
        setValue = base64_default.a.decode(value);
    }
    return setValue;
}

function setCookie(key, value, expires) {
    var valueToString = '';
    if (value) {
        valueToString = String(value);
    }
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = base64_default.a.encode(valueToString);
    }

    if (expires) {
        js_cookie_default.a.set(key, setValue, { expires: expires });
    } else {
        js_cookie_default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function setToken(props) {
    clearToken();
    var token = props.token,
        expires_on = props.expires_on,
        firstName = props.firstName,
        lastName = props.lastName,
        email = props.email,
        isAdmin = props.isAdmin;

    setCookie(TOKEN, token);
    if (typeof token !== "undefined") setCookie(TOKEN, token);
    if (typeof expires_on !== "undefined") setCookie(EXPIRES_ON, expires_on);
    if (typeof firstName !== "undefined") setCookie(FIRSTNAME, firstName);
    if (typeof lastName !== "undefined") setCookie(LASTNAME, lastName);
    if (typeof email !== "undefined") setCookie(EMAIL, email);
    if (typeof isAdmin !== "undefined") setCookie(IS_ADMIN, isAdmin);
}

function setMeetingRoomId(meetingRoomId) {
    removeCookie(MEETINGROOMID);
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID, meetingRoomId, 365);
}

function setMeetingRoomIdHeader(meetingRoomId) {
    removeCookie(MEETINGROOMID);
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID_HEADER, meetingRoomId, 365);
}

function setMeetingRoomIdFooter(meetingRoomId) {
    removeCookie(MEETINGROOMID);
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID_FOOTER, meetingRoomId, 365);
}

function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(FIRSTNAME);
    removeCookie(LASTNAME);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
}

function getAllToken() {
    var _ref;

    if (!getCookie(TOKEN)) return {};
    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, FIRSTNAME, getCookie(FIRSTNAME)), _defineProperty(_ref, LASTNAME, getCookie(LASTNAME)), _defineProperty(_ref, EMAIL, getCookie(EMAIL)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getMeetingRoomId() {
    return getCookie(MEETINGROOMID);
}

function getMeetingRoomIdHeader() {
    return getCookie(MEETINGROOMID_HEADER);
}

function getMeetingRoomIdFooter() {
    return getCookie(MEETINGROOMID_FOOTER);
}
// CONCATENATED MODULE: ./src/display/lib/setting.js
var timeZone = 'Asia/Bangkok';
var dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
var LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm';
var ShortDateTimeFormat = 'D MMM YYYY HH:mm';
var LongDateFormat = 'ddd MMM D, YYYY';
var ShortDateFormat = 'D MMM YYYY';
var timeFormat = 'HH:mm';
var getNumberOrdinal = function getNumberOrdinal(n) {
   return ["st", "nd", "rd"][((n + 90) % 100 - 10) % 10 - 1] || "th";
};
// CONCATENATED MODULE: ./src/display/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return O365_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return CORE_SOCKET_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return CORE_SOCKET; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return CORE_FRONTEND; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return TIME_BACK_TO_HOME; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return TIME_INTERVAL; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return setToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return setMeetingRoomId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return setMeetingRoomIdHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return setMeetingRoomIdFooter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getAllToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getMeetingRoomId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getMeetingRoomIdHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getMeetingRoomIdFooter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return dateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return LongDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ShortDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return LongDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ShortDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getNumberOrdinal; });




/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_LOAD_ROOMSTATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_LOAD_ROOMSTATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_LOAD_ROOMSTATUS_FAILURE; });
/* unused harmony export CORE_LOAD_EVENT_REQUEST */
/* unused harmony export CORE_LOAD_EVENT_SUCCESS */
/* unused harmony export CORE_LOAD_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_LOAD_ROOMS_FAILURE; });
// export const LOGOUT = 'LOGOUT'

var CORE_LOGIN_REQUEST = 'CORE_LOGIN_REQUEST';
var CORE_LOGIN_SUCCESS = 'CORE_LOGIN_SUCCESS';
var CORE_LOGIN_FAILURE = 'CORE_LOGIN_FAILURE';

var CORE_LOAD_ROOMSTATUS_REQUEST = 'CORE_LOAD_ROOMSTATUS_REQUEST';
var CORE_LOAD_ROOMSTATUS_SUCCESS = 'CORE_LOAD_ROOMSTATUS_SUCCESS';
var CORE_LOAD_ROOMSTATUS_FAILURE = 'CORE_LOAD_ROOMSTATUS_FAILURE';

var CORE_LOAD_EVENT_REQUEST = 'CORE_LOAD_EVENT_REQUEST';
var CORE_LOAD_EVENT_SUCCESS = 'CORE_LOAD_EVENT_SUCCESS';
var CORE_LOAD_EVENT_FAILURE = 'CORE_LOAD_EVENT_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/display/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 500, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            res.json().then(function (json) {
                console.log(json);
                // return json.value
                return reject(_extends({ statusText: res.message }, json));
            });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(393);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/display/lib/index.js + 3 modules
var lib = __webpack_require__(128);

// CONCATENATED MODULE: ./src/display/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var isCORE = entry.types[0].startsWith("CORE");

            if (isCORE) {
                var token = Object(lib["l" /* getToken */])();

                if (!token) return next(action);

                var _getAllToken = Object(lib["h" /* getAllToken */])(),
                    expires_on = _getAllToken.expires_on;

                var currentTime = moment_timezone_default()().format(lib["g" /* dateTimeFormat */]);
                var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expires_on).diff(currentTime));
                var minutes = duration.asMinutes();

                if (minutes < 10) {
                    console.log('request new token');
                    fetch(lib["a" /* CORE_API_ENDPOINT */] + '/user/verify', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                        // body: JSON.stringify({ access_token })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (json) {
                        var token = json.token,
                            expires_on = json.expires_on,
                            isIntegration = json.isIntegration,
                            user = json.user;


                        var body = {
                            token: token,
                            expires_on: expires_on,
                            isIntegration: isIntegration,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            email: user.email,
                            isAdmin: user.isAdmin
                        };
                        Object(lib["p" /* setToken */])(body);
                    }).then(function () {
                        return next(action);
                    });
                } else {
                    next(action);
                }
                // next(action)
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/display/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// import types from '../types'
/* harmony default export */ var setToken = (function (store) {
	return function (next) {
		return function (action) {

			var entry = action[CALL_API];
			// const ignorTypes  = [types.]
			if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

			var token = void 0;
			var entryType = entry.types[0];
			if (typeof entryType === 'string' && entryType.startsWith("CORE")) {
				token = Object(lib["l" /* getToken */])();
			}

			if (!token) return next(action);

			entry.headers = setToken__extends({}, entry.headers);
			if (token) {
				entry.headers.Authorization = 'Bearer ' + token;
				// entry.headers["Access-Control-Allow-Origin"] = "*"
				// entry.headers["Access-Control-Allow-Methods"] = "DELETE, POST, GET, OPTIONS"
				// entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With"
			}
			next(action);
		};
	};
});
// CONCATENATED MODULE: ./src/display/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { height: '100vh', lineHeight: 50, textAlign: 'center', verticalAlign: 'middle' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Icon */], { loading: true, name: 'spinner', size: 'massive' })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(396);


/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(408);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(127);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(417);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/display/store/schema.js


var eventSchema = new src["schema"].Entity('events');
// EXTERNAL MODULE: ./src/display/store/configureStore.js
var configureStore = __webpack_require__(423);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/display/store/index.js


// EXTERNAL MODULE: ./src/display/lib/index.js + 3 modules
var lib = __webpack_require__(128);

// CONCATENATED MODULE: ./src/display/lib/routePermission.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		var token = Object(lib["l" /* getToken */])();
		return !!token;
	}
};

var GetPathname = function GetPathname(props) {
	var pathname = "room";
	// console.log("000000", props.location)
	if (props && props.location && props.location.pathname) {
		// console.log("1111111", props.location.pathname)
		// pathname = props.location.pathname.replace('/', "")
		var setPath = props.location.pathname.replace('/', "");
		if (setPath) {
			pathname = setPath;
		}
	}
	return pathname;
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["c" /* Route */], _extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				// console.log("999999",)
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/login/' + GetPathname(props) });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["c" /* Route */], _extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}

			if (Auth.isAuthenticated() === true && props.match.url === "/") {
				return react_default.a.createElement(es["b" /* Redirect */], { to: '/' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};


// EXTERNAL MODULE: ./src/display/features/ui/components/Loadable.js
var Loadable = __webpack_require__(391);

// CONCATENATED MODULE: ./src/display/features/ui/components/Routes.js





var AsyncNotFound = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, 923));
    }
});

var AsyncLogin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, 924));
    }
});

var AsyncHomeDisplay = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, 925));
    }
});

var AsyncPageHeader = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 926));
    }
});

var AsyncPageFooter = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 927));
    }
});

var AsyncHomeSelectRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 928));
    }
});

var AsyncSelectRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 929));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: AsyncHomeDisplay }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login/:path', component: AsyncLogin }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/room', component: AsyncHomeSelectRoom }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roomheader', component: AsyncPageHeader }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roomfooter', component: AsyncPageFooter }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roomsplit/:key', component: AsyncSelectRoom }),
        react_default.a.createElement(routePermission_PublicRoute, { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/display/features/ui/components/App.js



/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(Routes, null)
        )
    );
});
// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(176);

// CONCATENATED MODULE: ./src/display/features/ui/components/Root.prod.js







var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(App, null)
            )
        )
    );
});

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(424);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(67);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__(425);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/display/middlewares/index.js + 3 modules
var display_middlewares = __webpack_require__(390);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 225 modules
var redux_form_es = __webpack_require__(431);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var reapop_lib = __webpack_require__(436);
var reapop_lib_default = /*#__PURE__*/__webpack_require__.n(reapop_lib);

// EXTERNAL MODULE: ./src/display/types.js
var types = __webpack_require__(177);

// CONCATENATED MODULE: ./src/display/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
};

/* harmony default export */ var reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["n" /* CORE_LOGIN_REQUEST */]:
        case types["CORE_EXTEND_REQUEST"]:
        case types["CORE_DELETE_REQUEST"]:
            return _extends({}, state, {
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["o" /* CORE_LOGIN_SUCCESS */]:
        case types["CORE_EXTEND_SUCCESS"]:
        case types["CORE_DELETE_SUCCESS"]:
            return _extends({}, state, {
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["m" /* CORE_LOGIN_FAILURE */]:
        case types["CORE_EXTEND_FAILURE"]:
        case types["CORE_DELETE_FAILURE"]:
            var _action$payload = action.payload,
                statusText = _action$payload.statusText,
                code = _action$payload.code,
                message = _action$payload.message;

            var returnData = _extends({}, state, {
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            });
            return returnData;

        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/display/reducers/reducerRoom.js


/* harmony default export */ var reducerRoom = ({
   roomStatus: function roomStatus() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var action = arguments[1];

      switch (action.type) {
         case types["h" /* CORE_LOAD_ROOMSTATUS_REQUEST */]:
            return state;
         case types["i" /* CORE_LOAD_ROOMSTATUS_SUCCESS */]:
            if (action.payload) {
               var payLoad = action.payload;
               return payLoad;
            } else return {};
         default:
            return state;
      }
   },
   rooms: function rooms() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var action = arguments[1];

      switch (action.type) {
         case types["k" /* CORE_LOAD_ROOMS_REQUEST */]:
            return state;
         case types["l" /* CORE_LOAD_ROOMS_SUCCESS */]:
            if (Array.isArray(action.payload)) {
               var payLoad = action.payload;
               return payLoad;
            } else return [];
         default:
            return state;
      }
   }
});
// CONCATENATED MODULE: ./src/display/reducers.js






/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    notifications: Object(reapop_lib["reducer"])(),
    ui: reducer,
    roomStatus: reducerRoom.roomStatus,
    rooms: reducerRoom.rooms
}));
// CONCATENATED MODULE: ./src/display/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [display_middlewares["c" /* checkToken */], display_middlewares["d" /* setToken */], display_middlewares["b" /* api */], lib_default.a];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ })

},[395]);


// WEBPACK FOOTER //
// app.4c910ef7cddb22115420.js